module.exports = __webpack_public_path__ + "dist/assets/img/advice.57cdde26.svg";